<template>
  <div>
    <b-row class="mt-1">
      <b-col>
        <c-tel-input
          inputType="number"
          v-model="authentication.phone"
          class="m-0"
          :defaultInput="authentication.phone"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="email"
          lableText="Email"
          v-model="authentication.email"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="username"
          lableText="User Name"
          v-model="authentication.userName"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Password"
          v-model="authentication.password"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <eb-select
          :label="'text'"
          placeholder="Security Question"
          :options="securityQuestions"
          v-model="authentication.securityQuestions.question"
          :selected="authentication.securityQuestions.question"
        ></eb-select>
      </b-col>
    </b-row>

    <b-row class="sqanswer">
      <b-col>
        <c-input
          inputType="text"
          inputId="sqa"
          lableText="Security Question Answers"
          v-model="authentication.securityQuestions.answer"
        />
      </b-col>
    </b-row>
    <slot name="footer-button" :data="authentication"></slot>
  </div>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import { mapGetters } from "vuex";
export default {
  name: "Authentication",
  data() {
    return {
      securityQuestions: [
        {
          text: "what is your mother maiden name",
          value: "what is your mother maiden name",
        },
        {
          text: "what is your first school",
          value: "what is your first school",
        },
        { text: "your first car model", value: "your first car model" },
      ],
      authentication: {
        phone: "",
        email: "",
        userName: "",
        password: "",
        securityQuestions: {
          answer: "",
          question: "",
        },
      },
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
  },
  methods: {},
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
  },
  mounted() {
    if (this.partnerAllData.authentication) {
      this.authentication.phone = this.partnerAllData.authentication.phone;
      this.authentication.email = this.partnerAllData.authentication.email;
      this.authentication.userName = this.partnerAllData.authentication.userName;
      this.authentication.securityQuestions.question =
        this.partnerAllData.authentication.securityQuestions.question || "";
      this.authentication.securityQuestions.answer =
        this.partnerAllData.authentication.securityQuestions.answer || "";
    }
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}
.sqanswer {
  margin-top: -12px !important;
}
</style>
